var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.53333 0.546509L0.799992 8.81317L8.53332 16.5465","stroke":"black","strokeWidth":"1.6","strokeLinejoin":"round"}));
}

ArrowLeft.defaultProps = {"width":"10","height":"18","viewBox":"0 0 10 18","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
